<template>
    <div class="singleProduct">
        <header class="singleProduct__header" :style="{ backgroundImage: 'url(' + bgImage + ')', backgroundPositionY: scrollPosition + 'px' }" :class="{classA: scrollPosition < 100, classB: scrollPosition > 100}">
            <div class="container">
                <div class="gr-12">
                    <router-link to="/products" class="singleProduct__backLink">Products</router-link>
                    <h1 class="singleProduct__title">{{ singleProduct.title }}</h1>
                    <p class="singleProduct__categories">Interior Design  / 3D Visualization</p>
                </div>
            </div>
        </header>

        <div class="container">
            <div class="gr-12 gr-10@lg push-1@lg">
                <div class="singleProduct__mainImg">
                    <figure class="singleProduct__figure">
                        <img v-if="singleProduct.post_image" :src="singleProduct.post_image" alt="" class="rspimg">
                        <img v-else src="@/assets/singleProduct.jpg" alt="" class="rspimg">
                    </figure>

                    <h2 class="singleProduct__description" ref="ref1">
                        Cras mattis consectetur purus sit amet fermentum. Aenean eu leo quam. Pellentesque ornare lacinia quam venenatis vestibulum.
                    </h2>
                </div>
            </div>

            <div class="gr-12 gr-8@lg push-2@lg">
                <div class="wysiwyg" v-html="singleProduct.description"></div>
            </div>

            <div class="gr-12">
                <SimpleGallery />
            </div>
        </div>

        <div class="relatedProducts">
            <div class="container">
                <div class="gr-12">
                    <h3 class="heading heading--small">Other products</h3>
                </div>
            </div>
            
            <div class="relatedProducts__slider">
                <Swiper />
            </div>
        </div>

        <Prefooter />
        <Footer />
    </div>
</template>

<script>
import axios from 'axios';
import { TimelineLite, Back } from 'gsap'

// components
import SimpleGallery from '@/components/SimpleGallery.vue'
import Swiper from '@/components/Swiper.vue'
import Prefooter from '@/components/Prefooter.vue';
import Footer from '@/components/Footer.vue'


//import icons
import '@/compiled-icons/arrow-left';

export default {
    name: 'productSingle',
    components: {
        SimpleGallery,
        Prefooter,
        Footer,
        Swiper
    },
    props: {
        productID: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            singleProduct: [],
            categories: [],
            bgImage: require('@/assets/bg/singleProduct.jpg'),
            scrollPosition: null,
            name: this.$route.name
        }
    },
    created() {
        // alert('Ovoje productID: ' + this.$route.params.productID);
        // this.getProducts()
        this.getSinglePost();
    },
    mounted() {
        // change class on <body>
        this.toggleBodyClass('addClass', 'page-singleProduct');

        // get post data
        // this.getSinglePost();

        // update scroll behaviour
        window.addEventListener('scroll', this.updateScroll);
    },
    updated() {
        // get post data every time we update the component
        // this.getSinglePost();
    },
    destroyed() {
        // removes class from <body>
        this.toggleBodyClass('removeClass', 'page-singleProduct');
    },
    methods: {
        toggleBodyClass(addRemoveClass, className) {
            const el = document.body;

            if (addRemoveClass === 'addClass') {
                el.classList.add(className);
            } else {
                el.classList.remove(className);
            }
        },


        updateScroll: function () {
            this.scrollPosition = window.scrollY
        },

        // getProducts() {
        //     var urlAPI = 'https://next.json-generator.com/api/json/get/N1suhTnVw';

        //     axios.get(urlAPI)
        //         .then(response => {
        //             this.productList = response.data
        //         })
        // },


        getSinglePost: function () {
            // base Url of the API
            const baseUrl = 'https://www.studenac.hr/api/recipes';
            const token = '?token=hHnqxgrqmTztC8SkjJqgOPk3jo8dLwp0';
            const id = this.$route.params.productID;
            // const id = this.$props.productID;

            axios.get(baseUrl + token + '&id=' + id).then(response => {
                this.singleProduct = response.data.recipes[0]
            //     console.log(response);
            // }).catch(error => {
            //     console.log(error);
            })
        },

        // getCategories: function () {
        //     // base Url of the API
        //     const baseUrl = 'https://www.studenac.hr/api/recipes';
        //     const token = '&token=hHnqxgrqmTztC8SkjJqgOPk3jo8dLwp0';
        //     const id = this.$route.params.productID;

        //     axios.get(baseUrl + '?id=' + id + token).then(response => {
        //         this.categories = response.data.categories[0]
        //         // console.log(this.singleProduct);
        //     }).catch(error => {
        //         // console.log(error);
        //     })
        // },

        animationOnEnterPage: function () {
            console.log('animationOnEnterPage');

            const timeline = new TimelineLite() 
            const { ref1, ref2 } = this.$refs


            timeline.set(ref1, {
                autoAlpha: 0,
                scale: .5,
            });

            timeline.to(ref1, 2, {
                scale: 1,
                autoAlpha: 1,
            });
        }
    },
    // beforeRouteEnter: function(to, from, next) {
        // console.log('beforeRouteEnter ');
        // this.getSinglePost();

        // next(vm => { 
        //     // access to component's instance using `vm` .
        //     vm.animationOnEnterPage();
        //     next();
        // }) 
    // },
    beforeRouteUpdate(to, from, next) {
        next();

        // get updated post data
        this.getSinglePost();
    }
};
</script>


<style scoped lang="scss">
    // @import "@/scss/modules/_singleProduct.scss";
</style>